import { ca } from '@cian/analytics';

export const trackBubbleButtonClick = (chatId: string, bubbleType: string, buttonName: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Bubble',
    action: 'Click_sopr',
    label: 'Button',
    page: {
      extra: {
        chat_id: chatId,
        bubble_type: bubbleType,
        button_name: buttonName,
      },
    },
  });
};
